import { render } from "./PartnerPage.vue?vue&type=template&id=34b9f138"
import script from "./PartnerPage.vue?vue&type=script&lang=js"
export * from "./PartnerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__